export enum OrderBy {
    DUE_DATE_ASC,
    DUE_DATE_DESC,
    CREATION_DATE,
    ALPHABETICAL_A_Z,
    ALPHABETICAL_Z_A,
}
